import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Form from '@spothero/ui/form';
import FormGroup from '@spothero/ui/form-group';
import Label from '@spothero/ui/label';
import Select from '@spothero/ui/select';
import TextInput from '@spothero/ui/text-input';
import APIUtils from '@spothero/utils/api';
import VehicleAPI from 'api/vehicle';
import AutoSuggestInput from '@spothero/ui/auto-suggest-input';
import IconSearch from '@spothero/icons/search';
import SentryUtils from '@spothero/utils/sentry';
import get from 'lodash/get';

class VehicleSelect extends Component {
    static propTypes = {
        className: PropTypes.string,
        useLabels: PropTypes.bool,
        setOversizeFeeError: PropTypes.func,
        errorsInline: PropTypes.bool,
        user: PropTypes.object,
    };
    static defaultProps = {
        useLabels: true,
    };

    constructor(props) {
        super(props);

        this.state = {
            vehicleInfoId: null,
            unlistedModel: null,
            suggestions: [],
            stateOptions: [],
        };
    }

    componentDidMount() {
        this._getStates()
            .then(response => {
                const stateOptions = response.data.data.results[0].states.map(
                    result => ({
                        value: result.name,
                        label: result.value,
                    })
                );

                stateOptions.unshift({
                    value: '',
                    label: 'Select State',
                });

                this.setState({
                    stateOptions,
                });
            })
            .catch(error => {
                const errorMessage =
                    error &&
                    (error.message ||
                        error.statusText ||
                        get(error, 'response.data', ''));

                SentryUtils.addData({
                    caughtError: error,
                });
                SentryUtils.sendMessage({
                    message: errorMessage,
                    level: 'error',
                });
            });
    }

    _onSearchSuggestions = async event => {
        const term = event.target.value;
        const suggestions = [];

        try {
            let response = await VehicleAPI.getVehicleInfos(term); // eslint-disable-line prefer-const
            const results = response.data.data.results;
            const size = 10;

            results.slice(0, size).forEach(result =>
                suggestions.push({
                    ...result,
                    label: result.display_description,
                    id: result.id,
                })
            );
        } catch (error) {
            const errorMessage =
                error &&
                (error.message ||
                    error.statusText ||
                    get(error, 'response.data', ''));

            SentryUtils.addData({
                caughtError: error,
            });
            SentryUtils.sendMessage({
                message: errorMessage,
                level: 'error',
            });
        }

        suggestions.push({
            label: 'Vehicle not listed',
            unlisted: true,
            id: 0,
        });

        this.setState({
            suggestions,
        });
    };

    _onSuggestionSelect = suggestion => {
        const {id, unlisted} = suggestion;
        const vehicleInfoId = id ? Number(id) : null;

        this.setState({
            vehicleInfoId,
            unlistedModel: Boolean(unlisted),
        });
    };

    submit = () => {
        return this._vehicleSelect.submit();
    };

    _getStates = () => {
        return APIUtils.get('states/');
    };

    render() {
        const {className, useLabels, errorsInline, ...props} = this.props;
        const {
            vehicleInfoId,
            unlistedModel,
            suggestions,
            stateOptions,
        } = this.state;
        const classes = classNames('VehicleSelect', className);

        return (
            <div className={classes}>
                <Form
                    ref={node => {
                        this._vehicleSelect = node;
                    }}
                    id="VehicleSelect-form"
                >
                    <FormGroup>
                        {vehicleInfoId && (
                            <input
                                type="hidden"
                                name="vehicleInfoId"
                                value={vehicleInfoId}
                            />
                        )}
                        {unlistedModel && (
                            <input
                                type="hidden"
                                name="unlistedModel"
                                value={unlistedModel}
                            />
                        )}
                        {useLabels && (
                            <Label>Enter Vehicle Make and Model</Label>
                        )}
                        <AutoSuggestInput
                            {...props}
                            autoActivateFirstSuggest
                            icon={<IconSearch />}
                            onSuggestionSelect={this._onSuggestionSelect}
                            placeholder="Enter Vehicle Make & Model"
                            suggestions={suggestions}
                            onChange={this._onSearchSuggestions}
                            onInvalid={
                                !errorsInline ? this._onVehicleError : null
                            }
                            className={classes}
                            required
                        />
                        <span className="field-sub-text">
                            Example: Honda Civic
                        </span>
                        <TextInput
                            className="VehicleSelect-license-plate"
                            name="licensePlate"
                            label={
                                useLabels ? <Label>License Plate</Label> : null
                            }
                            placeholder="Enter License Plate"
                            max={8}
                            min={2}
                            mask="********"
                            onInvalid={
                                !errorsInline ? this._onLicensePlateError : null
                            }
                            required
                        />
                        {stateOptions && (
                            <div className="VehicleSelect-license-state-container">
                                <Select
                                    label={
                                        useLabels ? <Label>State</Label> : null
                                    }
                                    name="licenseState"
                                    className="VehicleSelect-license-state"
                                    items={stateOptions}
                                />
                                <span className="field-sub-text">Optional</span>
                            </div>
                        )}
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

export default VehicleSelect;
